import { DayObject, TimeOfDay } from "./date"
import { FolioDocumentTypeGroup } from "./folio/folio-document"
import { Place } from "./place"
import { TravelerGroup } from "./trip"
import { WebSearchResult } from "./web-search-result"

export interface PlaceItem {
  kind: "place"
  place: Place
}

export interface BookedExternalPlaceItem {
  kind: "bookedExternalPlace"
  place: Place
  bookedExternal: {
    start: DayObject
    end: DayObject
    travelers: TravelerGroup
    reservationTime?: TimeOfDay
  }
}

export interface WebSearchResultItem {
  kind: "webSearchResult"
  title: string
  searchResult?: WebSearchResult
  messageId?: number
  webSearchResultId?: string
}

export interface UnknownEntityItem {
  kind: "unknownEntity"
  title: string
  messageId?: number
}

export interface FolioItem {
  kind: "folio"
  folioTypeGroup: FolioDocumentTypeGroup
}

export interface FlightItineraryItem {
  kind: "flightItinerary"
  flightItineraryIds: number[]
  airlines?: Array<{ name: string; iata: string; logo_url?: string | null }>
}

export type TripAddableItem =
  | PlaceItem
  | BookedExternalPlaceItem
  | WebSearchResultItem
  | UnknownEntityItem
  | FolioItem
  | FlightItineraryItem

export const createPlaceItem = (place: Place): PlaceItem => ({
  kind: "place",
  place,
})

export const createBookedExternalPlaceItem = (
  place: Place,
  bookedExternal: BookedExternalPlaceItem["bookedExternal"]
): BookedExternalPlaceItem => ({
  kind: "bookedExternalPlace",
  place,
  bookedExternal,
})

export const createWebSearchResultItem = (
  item: Omit<WebSearchResultItem, "kind">
): WebSearchResultItem => ({
  kind: "webSearchResult",
  ...item,
})

export const createUnknownEntityItem = (
  item: Omit<UnknownEntityItem, "kind">
): UnknownEntityItem => ({
  kind: "unknownEntity",
  ...item,
})

export const createFolioItem = (
  folioTypeGroup: FolioDocumentTypeGroup
): FolioItem => ({
  kind: "folio",
  folioTypeGroup,
})

export const createFlightItineraryItem = (
  item: Omit<FlightItineraryItem, "kind">
): FlightItineraryItem => ({
  kind: "flightItinerary",
  ...item,
})

export const isPlaceBasedItem = (
  item: TripAddableItem
): item is PlaceItem | BookedExternalPlaceItem =>
  item.kind === "place" || item.kind === "bookedExternalPlace"
